import { useId, type SVGProps } from 'react'

/**
 * Clarity logo mark (four diamonds). Not imported through SVGR — `icon: true` in Vite would
 * square sizing independently of the 24×24 viewBox, and shared gradient ids collide across
 * instances the same way the wordmark X fade did.
 * Gradient stops use --palette-brand-500, not currentColor, so the fade stays brand blue
 * whatever text color the SVG inherits.
 */
export function PaxtonLogoMark({ className, width = 24, height = 24, ...props }: SVGProps<SVGSVGElement>) {
  const uid = useId().replace(/:/g, '')
  const topRightId = `paxton-logo-mark-top-right-${uid}`
  const bottomLeftId = `paxton-logo-mark-bottom-left-${uid}`

  return (
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <rect x="12" width="8.48529" height="8.48529" transform="rotate(45 12 0)" fill="currentColor" />
      <rect x="18" y="18" width="8.48529" height="8.48529" transform="rotate(-135 18 18)" fill={`url(#${topRightId})`} />
      <rect x="6" y="6" width="8.48529" height="8.48529" transform="rotate(45 6 6)" fill={`url(#${bottomLeftId})`} />
      <rect x="12" y="12" width="8.48529" height="8.48529" transform="rotate(45 12 12)" fill="currentColor" />
      <defs>
        <linearGradient id={topRightId} className="paxton-logo-fade" x1="26.4959" y1="18" x2="17.949" y2="26.4335" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--palette-brand-500)" stopOpacity={0} />
          <stop offset="1" stopColor="var(--palette-brand-500)" />
        </linearGradient>
        <linearGradient id={bottomLeftId} className="paxton-logo-fade" x1="14.4959" y1="6" x2="5.94902" y2="14.4335" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--palette-brand-500)" stopOpacity={0} />
          <stop offset="1" stopColor="var(--palette-brand-500)" />
        </linearGradient>
      </defs>
    </svg>
  )
}
